module.exports = __webpack_public_path__ + "static/media/Brasidas.9072e834.jpg";